var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMaterialSymbolsPersonBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 16C10.85 16 9.775 16.175 8.775 16.525C7.775 16.875 6.85 17.3667 6 18V20H18V18C17.15 17.3667 16.225 16.875 15.225 16.525C14.225 16.175 13.15 16 12 16ZM6 22C5.45 22 4.97933 21.8043 4.588 21.413C4.19667 21.0217 4.00067 20.5507 4 20V4C4 3.45 4.196 2.97933 4.588 2.588C4.98 2.19667 5.45067 2.00067 6 2H18C18.55 2 19.021 2.196 19.413 2.588C19.805 2.98 20.0007 3.45067 20 4V20C20 20.55 19.8043 21.021 19.413 21.413C19.0217 21.805 18.5507 22.0007 18 22H6ZM12 14C12.9667 14 13.7917 13.6583 14.475 12.975C15.1583 12.2917 15.5 11.4667 15.5 10.5C15.5 9.53333 15.1583 8.70833 14.475 8.025C13.7917 7.34167 12.9667 7 12 7C11.0333 7 10.2083 7.34167 9.525 8.025C8.84167 8.70833 8.5 9.53333 8.5 10.5C8.5 11.4667 8.84167 12.2917 9.525 12.975C10.2083 13.6583 11.0333 14 12 14Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaterialSymbolsPersonBook);
export default __webpack_public_path__ + "static/media/material-symbols_person-book.75dcb3b172dd471c330a555268816da4.svg";
export { ForwardRef as ReactComponent };